

<template>
  <div class="content-wrapper mt-6">
    <div>
      <VCard class="pa-10 pt-8">
        <h2>How RM Works</h2>
        <p class="mt-4">
          <b class="">RM-Preferred Reservations</b><span class="">&nbsp;is trusted by high profile artists, athletes, executives & other luxury diners for reservations, events, & insights</span>
        </p>
        <p class="">
          <span class="">Here&rsquo;s how it works:</span>
        </p>
        <h4 class="">
          Reservations:
        </h4>
        <ol
          class=""
          start="1"
        >
          <li class="">
            Select your favorite(s) restaurant & preferred date, time & party size
          </li>
          <li class="">
            <span class="">Restaurant&#39;s general availability will be presented in case it is available to book directly</span>
            <ul class="">
              <li class="">
                <span class="">If available, book directly - confirmation email can be sent to RM to add to your activity data<br></span>
              </li>
            </ul>
          </li>
          <li class="">
            <span class="">If  your desired time is N/A and you are a member of our Premium or Platinum service, you can submit a Preferred Request to try & secure that reservation.  Members of Premium can submit requests to Preferred Restaurants and members of Platinum can submit requests to Preferred Restaurants and Member Favorites.
              Preferred requests require guaranteed Food & Beverage (F&B) spend - restaurants charge/waive spend, if not met, at their sole discretion.  </span>
          </li>
          <li class="">
            <span class="">Once your request is submitted, it is shared with the Restaurant(s).  They will then review & choose to accept or decline</span>
            <ul class="">
              <li class="">
                <span class="">If they accept, you will receive a confirmation via email from us and also a confirmation text/email from the restaurant via their reservation platform (OpenTable, Resy, etc.)<br></span>
              </li>
              <li class="">
                <span class="">If they decline, you will receive an email that may include alternate times and/or spends that may work.  You can then resubmit for that restaurant or choose another one<br></span>
              </li>
              <li class="">
                <span class="">If you submitted a request for multiple restaurants, you’ll be booked with the first one to accept<br></span>
              </li>
            </ul>
          </li>
        </ol>

        <h4 class="mt-4">
          Private/Group:
        </h4>
        <ol
          class=""
          start="1"
        >
          <li class="">
            Select your  desired date, time, party size, & room preference & up to 10 restaurants
          </li>
          <li class="">
            Once submitted, your event request is shared with your chosen restaurants.  Availability, pricing & room options are then shared with you once restaurants respond.
          </li>
          <li class="">
            You’ll then be connected with the restaurant you would like to book your event with
          </li>
        </ol>
        <p class="mt-2 ml-4">
          Submitting event requests requires being a member of our Premium or Platinum service.  Members of Premium can submit requests to Preferred Restaurants and members of Platinum can submit requests to Preferred Restaurants and Member Favorites
        </p>
        <h4 class="">
          Please note:
        </h4>
        <ul class="">
          <li class="">
            We are a reservations & event service that  facilitates access to reservations & pricing/availability for events.  The use of our service requires submission via our request form on our app.
          </li>
          <li class="">
            <span class="">Restaurants have sole discretion to accept or decline Preferred Requests & Event Requests
            </span>
            <ul class="">
              <li class="">
                <span class="">This is based on availability &/or the attractiveness of your request - including the minimum spend, your profile &/or your/your firm’s dining frequency</span>
              </li>
            </ul>
          </li>
        </ul>

        <ul class="">
          <li class="">
            <span>We don’t provide recommendations - we are not editorial. However, on our </span>
            <RouterLink
              to="/trending"
            >
              Trending
            </RouterLink><span
              class=""
            >&nbsp;page you can view Top Booked & Just Booked restaurants by members, and on our </span>
            <RouterLink
              to="/discover"
            >
              Favorites
            </RouterLink>
            page you can view Member Favorites & Preferred Restaurants
          </li>
          <li class="">
            <span class="">We can’t assist with additional private event planning - just finding pricing & availability</span>
          </li>
        </ul>
        <p class="">
          <span class="" />
        </p>
        <p class="">
          <span class="" />
        </p>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss" scoped>
ol{
  margin-left: 2rem;
}

ol li{
  list-style-type: decimal;
}

ul {
  margin-left: 2em;
}

ul li{
  list-style-type: circle;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: false
</route>
